export enum OnboardingView {
  BASE_VIEW = 'BASE_VIEW', // "Getting started" steps & "Need assistance?" links
  MERCHANT_TYPE_SELECTION_VIEW = 'MERCHANT_TYPE_SELECTION_VIEW',
  INDIVIDUAL_FORM_VIEW = 'INDIVIDUAL_FORM_VIEW',
  COMPANY_FORM_VIEW = 'COMPANY_FORM_VIEW',
}
